import { render, staticRenderFns } from "./DashboardMonthlyDeliveryCharge.vue?vue&type=template&id=8a1843e6&scoped=true&"
import script from "./DashboardMonthlyDeliveryCharge.vue?vue&type=script&lang=js&"
export * from "./DashboardMonthlyDeliveryCharge.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMonthlyDeliveryCharge.vue?vue&type=style&index=0&id=8a1843e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1843e6",
  null
  
)

export default component.exports